/*
 * @Author: your name
 * @Date: 2018-08-03 14:02:22
 * @LastEditTime: 2021-07-09 18:39:01
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: /cloud-recruit/src/hook/index.js
 */
import store from 'store';

import {cancelRequest} from 'utils/ajax';
import {clearResumeData} from 'actions/resumeSearch'

// 已经登录如果再次进入登陆页,跳转到首页
export const onEnterLoginHook = (nextState,replace) => {
    const {token} = store.get('token') || {};
    if(token) replace({pathname:'/'});
}

// 权限验证
export const requireAuthHook = (nextState,replace) => {
    const {token} = store.get('token') || {};
    if(!token) replace({pathname:'/login'});
    // 修改网页title
    const {routes} = nextState,
    title = routes[routes.length - 1 ].breadcrumbName;
    document.title = `51招聘云 - ${title ? title : routes[routes.length - 2 ].breadcrumbName}`;  
}

export const requireHook = (nextState,replace) => {
    // 修改网页title
    const {routes} = nextState,
    title = routes[routes.length - 1 ].breadcrumbName;
    document.title = `51招聘云 - ${title ? title : routes[routes.length - 2 ].breadcrumbName}`;  
}

// 离开页面触发此钩子
export const onLeavePage = (nextState,replace) => {
    cancelRequest();
}


// WEBPACK FOOTER //
// ./src/hook/index.js